import type { TableUrlState } from "./components/datatable/types/data-table";

export const MIN_NAME_LENGTH = 3;
export const MAX_NAME_LENGTH = 20;

export const MIN_TEXT_LENGTH = 0;
export const MAX_TEXT_LENGTH = 255;

export const ROW_HEIGHT = 48;

export const ALLOWED_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "icloud.com",
];

export const PAGE_SIZE = [10, 20, 30, 40, 50];

export const MIN_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 50;

export const defaultTableState: TableUrlState = {
  sorting: [],
  columnFilters: [],
  globalFilter: "",
  pagination: { cursor: null, pageSize: MIN_PAGE_SIZE, cursorHistory: [] },
  showDeleted: false,
} as const;
